export default "__VITE_ASSET__2ZbpX_3n__"